import { useCallback } from 'react';

import useSelectedTab from 'src/hooks/useSelectedTab';
import useShowPayment from 'src/hooks/useShowPayment';
import { SHOP_ORIGIN } from 'src/stores/shop/types';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { PurchasableProduct } from 'src/types/Payments';
import { pushEvent } from 'src/utils/event-gateway';

const useClickProductItem = (product: PurchasableProduct) => {
  const showPayment = useShowPayment();
  const { selectedTab } = useSelectedTab();

  const handleClickProduct = useCallback(() => {
    pushEvent({
      eventType: EVENT_TYPE.SHOP,
      eventName: EVENT_NAME.ANYWHERE__CLICK_SHOP_PRODUCT,
      eventParams: {
        tab: selectedTab.name,
        page: 'anywhere',
        action_category: 'click',
        target: 'shop_product',
        product_id: product.productId,
      },
    });
    showPayment({
      product,
      origins: [SHOP_ORIGIN.gemShop],
      originTab: selectedTab.name,
    });
  }, [product, selectedTab.name, showPayment]);

  return {
    handleClickProduct,
  };
};

export default useClickProductItem;
